import React from 'react';
import { SearchInput, RadioOption } from '@td-client-frontend/common';
import clsx from 'clsx';

export enum MarketingSearchType {
  ALL = 'all',
  GROUP = 'group'
}

interface MarketingSearchProps {
  searchType: string;
  onSearchTypeChange: (type: MarketingSearchType) => void;
  onSearchTermChange: (value: string) => void;
  searchValue: string;
}

const radioOptions: Record<string, string>[] = [
  { label: 'Group', value: MarketingSearchType.GROUP },
  { label: 'All', value: MarketingSearchType.ALL }
];

const MarketingSearch = ({ searchType, onSearchTypeChange, onSearchTermChange, searchValue }: MarketingSearchProps) => {
  const handleSearchTypeChange = (type: MarketingSearchType) => () => {
    onSearchTypeChange(type);
  };

  return (
    <div className="flex flex-col" data-testid="MarketingSearchWrapper">
      <div className="flex items-center space-x-3 justify-end sm:mr-2 md:mr-0">
        <span className="text-lg leading-5 text-gray-60">Search by</span>
        {radioOptions.map(({ value, label: optionLabel }) => {
          const input = {
            'type': 'radio',
            'checked': value === searchType,
            'data-testid': value
          };

          return (
            <RadioOption
              key={value}
              name="marketing_search_type"
              label={optionLabel}
              value={value}
              input={input}
              onChange={handleSearchTypeChange(value as MarketingSearchType)}
              labelClassName="text-lg leading-5 text-gray-65 focus-within:none"
              checkboxClassName={clsx(input.checked && 'border-blue-80')}
              activeCheckBoxClassName="bg-blue-80"
            />
          );
        })}
      </div>
      <SearchInput searchValue={searchValue} onChange={onSearchTermChange} />
    </div>
  );
};

export default MarketingSearch;
